import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  theme => ({
    // The calendar renders inside a portaled MUI Popper (anchored to the trigger)
    // so it escapes ancestor `overflow: hidden` and auto-repositions on-screen.
    popper: {
      zIndex: theme.zIndex.modal
    },
    dateRangeContainer: {
      boxShadow: '1px 1px 81px rgba(41,60,74,.18)',
      backgroundColor: theme.palette.common.white,
      borderRadius: 5
    },
    dateRangeToolbar: {
      display: 'flex',
      justifyContent: 'flex-end',
      borderTop: '1px solid #eff2f7',
      padding: 15
    }
  }),
  { name: 'DateRange' }
);
